'use client';

import { c as _c } from "react/compiler-runtime";
import { ComponentProps } from 'react';
import { useTranslations } from 'next-intl';
import IconGoLive from '@/components/assets/icon_go_live.svg';
import OptimizedImage from '@/components/OptimizedImage';
import ViverseButton from '@/components/ViverseButton';
import { useWorldCardContext } from '@/context/ViverseWorldCardContext';
import { Link } from '@/i18n/navigation';
import { cn } from '@/lib/utils';
export default function ViverseWorldCardBanner(t0) {
  const $ = _c(46);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  const t = useTranslations();
  const {
    resolvedImage,
    imageAlt,
    imageClassName,
    targetUrl,
    banner,
    info,
    isLive
  } = useWorldCardContext();
  let t1;
  if ($[3] !== banner) {
    t1 = banner ?? {};
    $[3] = banner;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    description: bannerDescription,
    ctaLabel: bannerCtaLabel,
    ctaHref2: bannerCtaHref2,
    ctaLabel2: bannerCtaLabel2,
    isHovered
  } = t1;
  let t2;
  if ($[5] !== className) {
    t2 = cn("group cursor-pointer rounded-lg select-none", "transition-all duration-300", className);
    $[5] = className;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      objectFit: "cover"
    };
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = isHovered !== undefined ? isHovered && "lg:scale-105 lg:brightness-110" : "lg:group-hover:scale-105 lg:group-hover:brightness-110";
  let t5;
  if ($[8] !== imageClassName || $[9] !== t4) {
    t5 = cn("transition-all duration-300", t4, imageClassName);
    $[8] = imageClassName;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== imageAlt || $[12] !== resolvedImage || $[13] !== t5) {
    t6 = <OptimizedImage src={resolvedImage} fill={true} alt={imageAlt} sizes="(max-width: 768px) 100vw, 50vw" style={t3} className={t5} draggable={false} fetchPriority="high" loading="eager" />;
    $[11] = imageAlt;
    $[12] = resolvedImage;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== isLive || $[16] !== t) {
    t7 = isLive && <div className="bg-vive-live absolute top-3 left-3 z-interactive flex items-center gap-1 rounded-full px-2 py-1"><IconGoLive className="size-3.5 fill-white" /><span className="text-[11px] leading-none font-semibold tracking-wide text-white uppercase">{t("live-badge-text.live")}</span></div>;
    $[15] = isLive;
    $[16] = t;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const t8 = isHovered !== undefined ? isHovered && "lg:opacity-90" : "lg:group-hover:opacity-90";
  let t9;
  if ($[18] !== t8) {
    t9 = cn("pointer-events-none absolute inset-0 bg-[linear-gradient(to_top,#08080a_0%,rgba(8,8,10,0.9)_20%,rgba(8,8,10,0.55)_42%,rgba(0,0,0,0.1)_65%,transparent_100%)] transition-opacity duration-500", t8);
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t9) {
    t10 = <div className={t9} />;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== info.title) {
    t11 = <h2 className="line-clamp-2 text-[16px] leading-6 font-semibold text-white">{info.title}</h2>;
    $[22] = info.title;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== bannerDescription) {
    t12 = bannerDescription && <p className="line-clamp-3 text-[12px] leading-4 text-[#b6c3d6]">{bannerDescription}</p>;
    $[24] = bannerDescription;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t11 || $[27] !== t12) {
    t13 = <div className="flex flex-col gap-2">{t11}{t12}</div>;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== bannerCtaHref2 || $[30] !== bannerCtaLabel || $[31] !== bannerCtaLabel2 || $[32] !== targetUrl) {
    t14 = (bannerCtaLabel || bannerCtaHref2 && bannerCtaLabel2) && <div className="flex flex-wrap items-center gap-2">{bannerCtaLabel && <Link data-component="world-card-v2-banner-cta" href={targetUrl} prefetch={false} className="w-fit"><ViverseButton variant="colorful" className="h-[34px] min-w-fit">{bannerCtaLabel}</ViverseButton></Link>}{bannerCtaHref2 && bannerCtaLabel2 && <Link data-component="world-card-v2-banner-cta-2" href={bannerCtaHref2} prefetch={false} className="w-fit"><ViverseButton variant="secondary" className="h-[34px] min-w-fit">{bannerCtaLabel2}</ViverseButton></Link>}</div>;
    $[29] = bannerCtaHref2;
    $[30] = bannerCtaLabel;
    $[31] = bannerCtaLabel2;
    $[32] = targetUrl;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t13 || $[35] !== t14) {
    t15 = <div className="absolute right-0 bottom-0 left-0 flex flex-col gap-4 p-4">{t13}{t14}</div>;
    $[34] = t13;
    $[35] = t14;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== t10 || $[38] !== t15 || $[39] !== t6 || $[40] !== t7) {
    t16 = <div className="relative aspect-430/275 overflow-hidden rounded-lg">{t6}{t7}{t10}{t15}</div>;
    $[37] = t10;
    $[38] = t15;
    $[39] = t6;
    $[40] = t7;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  let t17;
  if ($[42] !== props || $[43] !== t16 || $[44] !== t2) {
    t17 = <div {...props} data-component="world-card-v2-banner" className={t2}>{t16}</div>;
    $[42] = props;
    $[43] = t16;
    $[44] = t2;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  return t17;
}